
import React from 'react';

interface ConversationRawDataProps {
  rawResponse: any;
}

export const ConversationRawData: React.FC<ConversationRawDataProps> = ({ rawResponse }) => {
  return (
    <div className="mt-6 p-4 border rounded-md bg-gray-50">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold">Raw Response Data</h3>
      </div>
      <div className="p-3 bg-white rounded border max-h-96 overflow-y-auto">
        <pre className="whitespace-pre-wrap text-xs font-mono">
          {JSON.stringify(rawResponse, null, 2)}
        </pre>
      </div>
    </div>
  );
};
